<template>
  <div class="ellipsis-text ellipsis-3" :style="{
      lineHeight: `${lineHeight}px`,
      '-webkit-line-clamp': lineClamp
  }">
      <div
      v-if="isSHowExpand" class="space" :style="{
      height: `${spaceHeight}px`
      }"></div>
      <div v-if="isSHowExpand" class="expand-btn" @click="handleExpand">{{ expand ? $t('pc_biz_ai_retract').d('收起') : $t('pc_kng_common_btn_pack_open').d('展开') }}</div>
      <span ref="textRef">{{ text }}</span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    lineHeight: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      isSHowExpand: false,
      lineClamp: 3,
      textHeight: 0,
      expand: false
    };
  },
  computed: {
    spaceHeight() {
      if (!this.expand) {
        return this.lineHeight * 2;
      }
      return this.textHeight - this.lineHeight;
    }
  },
  watch: {
    text: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          const textHeight = this.$refs.textRef.getBoundingClientRect().height;
          this.textHeight = textHeight;
          if (textHeight > this.lineHeight * 3) {
            this.isSHowExpand = true;
          }
          console.log(this.$refs.textRef.getBoundingClientRect(), val);
        });
      }
    }
  },
  methods: {
    handleExpand() {
      this.expand = !this.expand;
      if (this.expand) {
        this.lineClamp = 999;
      } else {
        this.lineClamp = 3;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .ellipsis-text {
    .space {
      width: 0;
      float: right;
    }
    .expand-btn {
      float: right;
      clear: both;
      cursor: pointer;
      color: #436bff;
    }
  }
  .ellipsis-3 {
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
</style>
